var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconChevronUp = function SvgIconChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 11.619a1.031 1.031 0 0 0-.07-1.381L8.937 4.396a1.03 1.03 0 0 0-1.46 0l-5.84 5.842a1.033 1.033 0 0 0 1.46 1.46l5.112-5.113 5.112 5.112a1.03 1.03 0 0 0 1.381.071l.079-.07.07-.08z",
    fillRule: "evenodd"
  })));
};

export default SvgIconChevronUp;